export const administration = {
    route: 'Administration',
    allHomesLabel: 'Alle Häuser',
    allUsersLabel: 'Alle Benutzer',
    sureToDeleteUserContent: 'Name des gelöschten Benutzer: ',
    sureToUndeleteUserContent: 'Name des wieder hergestellten Benutzer: ',
    invitationPending: 'Eine Einladung wurde verschickt'
};
